import { render, staticRenderFns } from "./DocMenu.vue?vue&type=template&id=00a1a746&scoped=true&"
import script from "./DocMenu.vue?vue&type=script&lang=js&"
export * from "./DocMenu.vue?vue&type=script&lang=js&"
import style0 from "./DocMenu.vue?vue&type=style&index=0&id=00a1a746&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a1a746",
  null
  
)

export default component.exports